/**
 * Tipologie articolo che identificano la MERCE (componenti fisici, su cui ha
 * senso lo sfrido). Stessa definizione del backend: TIPOLOGIE_PER_TIPO.MERCE in
 * backend/src/routes/distinte.js e TIPOLOGIE.MERCE in routes/fabbisogni.js.
 */
export const TIPOLOGIE_MERCE = ['ARTICOLO_FISICO', 'INTERCAMBIABILE'] as const;

export function isTipologiaMerce(tipologia: string | null | undefined): boolean {
  return !!tipologia && (TIPOLOGIE_MERCE as readonly string[]).includes(tipologia);
}
